import { useCallback } from "react";
import { useWebHaptics } from "web-haptics/react";
import { HAPTIC_LIGHT_NAV } from "../hapticPatterns";
import { AboutAppIcon, GalleryAppIcon } from "./AppIcons";
import wordmark from "../wordmark.svg";

function InstagramAppIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width={32}
      height={32}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" strokeWidth="1.75" />
      <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.75" />
      <circle cx="17.5" cy="6.5" r="1.25" fill="currentColor" stroke="none" />
    </svg>
  );
}

type AppId = "about" | "gallery";

type Props = {
  onOpenApp: (id: AppId) => void;
};

export function HomeScreen({ onOpenApp }: Props) {
  const { trigger } = useWebHaptics();
  const tap = useCallback(() => void trigger([...HAPTIC_LIGHT_NAV]), [trigger]);

  const openAbout = useCallback(() => {
    tap();
    onOpenApp("about");
  }, [tap, onOpenApp]);

  const openGallery = useCallback(() => {
    tap();
    onOpenApp("gallery");
  }, [tap, onOpenApp]);

  return (
    <div className="home-screen">
      <div className="home-wordmark">
        <div className="home-wordmark-widget">
          <img src={wordmark} alt="VFVLM" className="home-wordmark-img" width={352} height={92} />
        </div>
      </div>
      <div className="home-grid">
        <button type="button" className="app-icon" onClick={openAbout}>
          <span className="app-tile app-tile-about" aria-hidden>
            <AboutAppIcon className="app-tile-svg" />
          </span>
          <span className="app-label">About</span>
        </button>
        <button type="button" className="app-icon" onClick={openGallery}>
          <span className="app-tile app-tile-gallery" aria-hidden>
            <GalleryAppIcon className="app-tile-svg" />
          </span>
          <span className="app-label">Gallery</span>
        </button>
        <a
          className="app-icon"
          href="https://www.instagram.com/aideonquek/"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => tap()}
        >
          <span className="app-tile app-tile-instagram" aria-hidden>
            <InstagramAppIcon className="app-tile-svg" />
          </span>
          <span className="app-label">Instagram</span>
        </a>
      </div>
    </div>
  );
}
